<a
  [routerLink]="floor && ['/', mapPath, floor]"
  [queryParams]="{ target: targetId }"
>
  <div *ngIf="floor" class="floor" [ngClass]="{ large: large }">
    {{ floor }}
  </div>
  <img [ngClass]="{ large: large }" src="assets/img/location.svg" />
</a>
